import { useContext, useEffect } from 'react';
import { useSelector } from "react-redux";
import { updateVirtualNumber } from '../reducers/Action';
import { VoiceSendContext } from '../reducers/GlobalReduers';
import BasicSelect from "../../../custom/BasicSelect";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
   selectBox: {
      width: '50%',
   }
});

const VnNumber = props => {
    const { virtualNumbers } = useSelector((state) => (state.globalDialerReducer));
    const {states, dispatch} = useContext(VoiceSendContext);
    const classes = useStyles();

    useEffect(()=>{
        if (virtualNumbers && !virtualNumbers[0]){
            window.buyVirtualNumberModal(true);
        }
    },[virtualNumbers]);

    const hanldeVnNumber = (value) => {
        dispatch(updateVirtualNumber(value))
    }

    return(
        <div className="g-voice-send-vn-content">
            <span className="g-voice-send-vn-label">From Number:</span>
            <div className={`g-voice-send-vn-select-content ${classes.selectBox}`}>
                <BasicSelect
                    fullWidth
                    name="virtual_number"
                    options={virtualNumbers}
                    defaultText="Select a virtual number "
                    value={states.selectedVirtualNumber}
                    onChange={(event) => hanldeVnNumber(event.target.value)}
                    mapping={{
                        label: "label",
                        value: "value"
                    }}
                    subLabel={"nickname"}
                />
            </div>
        </div>
    )
}
export default VnNumber;